import { tv, type VariantProps } from "../../utils"

// A sensible container for page content. It centers the content and constrains the width.
export const pageContainerVariants = tv({
  base: "mx-auto min-h-0 w-full min-w-0",
  variants: {
    padding: {
      default: "max-w-[calc(theme(screens.4xl)+48px)] px-4 lg:px-6",
      left: "max-w-[calc(theme(screens.4xl)+48px)] pl-4 lg:pl-6",
      right: "max-w-[calc(theme(screens.4xl)+48px)] pr-4 lg:pr-6",
      none: "max-w-screen-4xl px-0",
    },
  },
  defaultVariants: {
    padding: "default",
  },
})

// For backward compatibility
export const pageContainerClassName = pageContainerVariants()

export type PageContainerVariants = VariantProps<typeof pageContainerVariants>
